import { Component } from "react"
import PropTypes from "prop-types"
import ClickOutside from "react-click-outside"
import classnames from "classnames"

import colors from "foundation/_colors_export.scss?export"

import { OrganizationMenuItem, orgShape } from "./selector_components"

export default class OrganizationSelectMenu extends Component {
  state = {
    open: false,
  }

  toggleOpen = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState({ open: !this.state.open })
  }

  onClickOutside = () => {
    this.setState({
      open: false,
    })
  }

  renderOrganizationMenuItems() {
    if (this.state.open) {
      return [
        ...this.props.organizations.map((org, index) => (
          <OrganizationMenuItem
            key={index}
            org={org}
            isActiveOrg={org.id === this.props.activeOrg.id}
            shouldRenderChevron={index === 0}
            menuIsOpen={this.state.open}
            toggleOpen={this.toggleOpen}
            handleMenuClick={this.handleOrganizationMenuItemClick}
          />
        )),
        <li
          key={this.props.organizations.length}
          className="add-item"
          title="Create a new Organization"
          onClick={e => {
            e.stopPropagation()
            this.setState({
              open: false,
            })
            this.props.createNewOrgHandler()
          }}
        >
          + New Org
        </li>,
      ]
    }
    return (
      <OrganizationMenuItem
        org={this.props.activeOrg}
        shouldRenderChevron={true}
        menuIsOpen={this.state.open}
        toggleOpen={this.toggleOpen}
        handleMenuClick={this.handleOrganizationMenuItemClick}
      />
    )
  }

  handleOrganizationMenuItemClick = org => {
    if (this.state.open) {
      if (
        this.props.initialOrg.id === org.id &&
        this.props.activeOrg.id === org.id
      ) {
        return this.setState({ open: false })
      }
      const url = org.services[0].url
      return window.location.assign(url)
    }
    this.setState({ open: true })
  }

  getColor(org) {
    if (org.color_hsl === "#000") {
      return colors.primaryTextColor
    }
    return org.color_hsl
  }

  render() {
    let navClass = classnames("organization-dropdown", {
      "orgs-open": this.state.open,
    })
    return (
      <ClickOutside onClickOutside={this.onClickOutside}>
        <nav className={navClass}>
          <ul
            className="org-list"
            style={{ backgroundColor: this.getColor(this.props.activeOrg) }}
          >
            {this.renderOrganizationMenuItems()}
          </ul>
        </nav>
      </ClickOutside>
    )
  }
}

OrganizationSelectMenu.propTypes = {
  createNewOrgHandler: PropTypes.func,
  initialOrg: orgShape,
  activeOrg: orgShape,
  organizations: PropTypes.arrayOf(orgShape),
  makerURI: PropTypes.string,
}
